import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/stopping-distance-calculator',
  component: () => import('../../routes/StoppingDistanceCalculator.svelte'),
  card: {
    id: 'stopping-distance-calculator',
    title: 'Stopping Distance Calculator',
    description: 'Calculate the total distance needed to stop a vehicle from highway speeds, accounting for reaction time, road conditions, and grade.',
    icon: 'directions_car',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/stopping-distance-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Stopping Distance Calculator – Vehicle Braking Distance Estimator',
    description: 'Free stopping distance calculator. Calculate total stopping distance including perception-reaction and braking phases. Covers dry, wet, and icy road conditions.',
  },
};

export default meta;